module.exports = __webpack_public_path__ + "static/sticker-course-ed642d35719be5277c219b966a581919.svg";